module.exports = __webpack_public_path__ + "img/usa-cervical-cancer-female.8b445af5.png";